import { FC } from "react";

import styles from "./detections.module.scss";

const Detections: FC = ({ children }) => (
  <div className={styles.detections}>
    {children}
    {/* <MultiScannerCard count={scannerCount} match={scannerMatch} />
    <YaraDetectionsCard matches={yaraMatches} /> */}
  </div>
);

export default Detections;
